export default {"src":"/_next/static/media/Reddit_Icon.cf1b1fa5.svg","height":75,"width":79,"blurWidth":0,"blurHeight":0};